import * as React from 'react';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import {DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { ConfigFieldValidation } from '../validation/ConfigurableItemValidator';
import { TextBox } from './TextBox';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useFieldApi } from 'informed';
import { inputClasses } from '../validation/ValidationClasses';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';

interface ConfigFieldTextBoxWithTooltipProps {
    id: string;
    field: string;
    labelName?: string;
    tooltipDescription: string;
    className: string;
    disabled?: boolean;
    validated: boolean;
    validate?: any;
    required: boolean;
    itemId: ConfigurableDataItemIds;
}

export const ConfigFieldTextBoxWithTooltip = (props: ConfigFieldTextBoxWithTooltipProps): JSX.Element => {
    const {
        id,
        field,
        labelName,
        tooltipDescription,
        className,
        disabled,
        validated,
        validate,
        required,        
        itemId,
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();

    const fieldApi = useFieldApi(field);

    if (dataItemConfigurationCollection === null || dataItemConfigurationCollection === undefined)
        throw 'Fields Configurations is not set';

    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    const tooltip = (
        <Tooltip id={id + '-tooltip'} style={{ zIndex: 2500 }}>
            {tooltipDescription}
        </Tooltip>
    );

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className}>
                <label htmlFor={id}>{labelName !== null ? labelName : item.displayText}</label>&nbsp;
                <OverlayTrigger placement="top" overlay={tooltip}>
                    <i aria-hidden="true" className="fa fa-info-circle text-muted" />
                </OverlayTrigger>                
                <TextBox
                    id={id}
                    field={field}
                    className={inputClasses(fieldApi.getError())}
                    validate={validated ? validate !== null ? validate : ConfigFieldValidation(item, required, validated) : null}
                    disabled={disabled} />
            </div>
        </Condition>
    </>
}
